import {Injectable} from '@angular/core';
import {Adapter} from '@secca/shared/interfaces/adapter';

export class RefundError {
  id: string;
  code: string;
  cause: string;
  text: string;
  actionText: string;
  action: string;

  public constructor(init?: Partial<RefundError>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class RefundErrorAdapter implements Adapter<RefundError> {
  adapt(item: any): RefundError {
    return new RefundError({
      id: item.id,
      code: item.code,
      cause: item.cause,
      text: item.text,
      actionText: item.actionText,
      action: item.action
    });
  }
}
